/**
 * @generated SignedSource<<8e4bd75ccdc9eb5f626ed8ae6ca3c0b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_ToolDataQuery$variables = {
  modelId: string;
  pricingFirst: number;
  productId: number;
  skipAI: boolean;
  skipAreaBackground: boolean;
  skipBulkVariations: boolean;
  skipCollage: boolean;
  skipExtensionFields: boolean;
  skipExtraOptions: boolean;
  skipImages: boolean;
  skipMoq: boolean;
  skipPlacement: boolean;
  skipPresetConfigurations: boolean;
  skipPricing: boolean;
  skipPrintingMethods: boolean;
  skipProfanity: boolean;
  skipQuote: boolean;
  skipShapes: boolean;
  skipTemplates: boolean;
};
export type productSidePanelContent_ToolDataQuery$data = {
  readonly additionalAttributesByProduct?: {
    readonly additionalAttributeID: number;
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly aiProductStagingRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly printTypeIDs: ReadonlyArray<number>;
    readonly productIDs: ReadonlyArray<number>;
  }>;
  readonly aiProductStagingRulesCount?: number;
  readonly aiVirtualModelRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly printTypeIDs: ReadonlyArray<number>;
    readonly productIDs: ReadonlyArray<number>;
  }>;
  readonly aiVirtualModelRulesCount?: number;
  readonly areaBackgroundRules?: ReadonlyArray<{
    readonly areaBackgroundRuleID: number;
    readonly name: string;
  }>;
  readonly areaBackgroundRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly areaBackgroundRulesCount?: number;
  readonly designTemplates?: ReadonlyArray<{
    readonly designTemplateId: number;
    readonly name: string;
    readonly previewUrl: string;
  }>;
  readonly designWithAISetting?: {
    readonly settingsID: number;
  } | null;
  readonly extensionFields?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly gridRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly gridRulesCount?: number;
  readonly hasShapes?: boolean;
  readonly imageGeneration?: {
    readonly id: string;
  } | null;
  readonly imageMacroCategories?: ReadonlyArray<{
    readonly hasImages: boolean;
  }>;
  readonly moqRulesCount?: number;
  readonly myAdditionalAttributes?: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly placementsOutput?: ReadonlyArray<{
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
    readonly placementOutputID: number;
  }>;
  readonly presetConfigurationsByProduct?: ReadonlyArray<{
    readonly compositionID: number;
    readonly id: string;
    readonly name: string | null;
    readonly previewImageUrl: string | null;
  }>;
  readonly pricings?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
        readonly printTypes: ReadonlyArray<{
          readonly printTypeID: number;
          readonly printTypeName: string;
        } | null> | null;
        readonly products: ReadonlyArray<{
          readonly productID: number;
        } | null> | null;
      };
    }> | null;
  } | null;
  readonly pricingsDetailed?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly printTypes?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
  readonly productMultipleVariantsRule?: {
    readonly attributeCodes: ReadonlyArray<string>;
    readonly bulkAsNameAndNumberEnabled: boolean;
    readonly enableImportCSV: boolean;
    readonly nameAndNumberEnabled: boolean;
    readonly options: string | null;
    readonly skipOptionForNameAndNumber: boolean;
  };
  readonly profanityFilterRulesCount?: number;
  readonly profanityFilterRulesForProduct?: {
    readonly printTypeRules: ReadonlyArray<{
      readonly key: number;
      readonly value: {
        readonly ruleID: number;
        readonly ruleName: string;
      } | null;
    }>;
    readonly productRule: {
      readonly ruleID: number;
      readonly ruleName: string;
    } | null;
  } | null;
  readonly quoteRulesCount?: number;
  readonly quoteRulesList?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
    readonly quoteRuleID: number;
  }>;
  readonly shapesAssignments?: {
    readonly printTypesIDs: ReadonlyArray<string>;
    readonly productsIDs: ReadonlyArray<string>;
  };
  readonly shapesAssignmentsForProduct?: {
    readonly forProduct: boolean | null;
    readonly printTypesIDs: ReadonlyArray<number>;
  };
  readonly shapesCount?: number;
};
export type productSidePanelContent_ToolDataQuery = {
  response: productSidePanelContent_ToolDataQuery$data;
  variables: productSidePanelContent_ToolDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pricingFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAI"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAreaBackground"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipBulkVariations"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipCollage"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipExtensionFields"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipExtraOptions"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipImages"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipMoq"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPlacement"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPresetConfigurations"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPricing"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPrintingMethods"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProfanity"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipQuote"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipShapes"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipTemplates"
},
v19 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "designTemplateId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v23 = [
  {
    "kind": "Variable",
    "name": "productID",
    "variableName": "modelId"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = {
  "condition": "skipPresetConfigurations",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v23/*:: as any*/),
      "concreteType": "Composition",
      "kind": "LinkedField",
      "name": "presetConfigurationsByProduct",
      "plural": true,
      "selections": [
        (v24/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "compositionID",
          "storageKey": null
        },
        (v21/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previewImageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v26 = {
  "kind": "Variable",
  "name": "productID",
  "variableName": "productId"
},
v27 = [
  (v26/*:: as any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypesIDs",
  "storageKey": null
},
v29 = {
  "condition": "skipShapes",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*:: as any*/),
      "concreteType": "ShapesAssignmentsForProduct",
      "kind": "LinkedField",
      "name": "shapesAssignmentsForProduct",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forProduct",
          "storageKey": null
        },
        (v28/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShapesAssignments",
      "kind": "LinkedField",
      "name": "shapesAssignments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productsIDs",
          "storageKey": null
        },
        (v28/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasShapes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shapesCount",
      "storageKey": null
    }
  ]
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricingName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricingID",
  "storageKey": null
},
v32 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypeID",
  "storageKey": null
},
v34 = {
  "condition": "skipPricing",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pricingFirst"
        },
        (v26/*:: as any*/)
      ],
      "concreteType": "PricingsDetailedConnection",
      "kind": "LinkedField",
      "name": "pricingsDetailed",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingsDetailedEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PricingGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v24/*:: as any*/),
                (v30/*:: as any*/),
                (v31/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v32/*:: as any*/),
      "concreteType": "PricingsConnection",
      "kind": "LinkedField",
      "name": "pricings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PricingGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v24/*:: as any*/),
                (v30/*:: as any*/),
                (v31/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PricingPrintType",
                  "kind": "LinkedField",
                  "name": "printTypes",
                  "plural": true,
                  "selections": [
                    (v33/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "printTypeName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PricingProduct",
                  "kind": "LinkedField",
                  "name": "products",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "productID",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "pricings(first:200)"
    }
  ]
},
v35 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleName",
    "storageKey": null
  }
],
v36 = {
  "condition": "skipProfanity",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*:: as any*/),
      "concreteType": "ProfanityFilterAssignmentsForProduct",
      "kind": "LinkedField",
      "name": "profanityFilterRulesForProduct",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfanityFilterRuleRef",
          "kind": "LinkedField",
          "name": "productRule",
          "plural": false,
          "selections": (v35/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfanityFilterPrintTypeRuleRef",
          "kind": "LinkedField",
          "name": "printTypeRules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfanityFilterRuleRef",
              "kind": "LinkedField",
              "name": "value",
              "plural": false,
              "selections": (v35/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profanityFilterRulesCount",
      "storageKey": null
    }
  ]
},
v37 = [
  (v24/*:: as any*/),
  (v21/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "productIDs",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "printTypeIDs",
    "storageKey": null
  }
],
v38 = {
  "alias": null,
  "args": (v27/*:: as any*/),
  "concreteType": "AIProductStagingRuleOutput",
  "kind": "LinkedField",
  "name": "aiProductStagingRulesByProduct",
  "plural": true,
  "selections": (v37/*:: as any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": (v27/*:: as any*/),
  "concreteType": "AIVirtualModelRuleOutput",
  "kind": "LinkedField",
  "name": "aiVirtualModelRulesByProduct",
  "plural": true,
  "selections": (v37/*:: as any*/),
  "storageKey": null
},
v40 = [
  (v24/*:: as any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageGenerationDTO",
  "kind": "LinkedField",
  "name": "imageGeneration",
  "plural": false,
  "selections": (v40/*:: as any*/),
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settingsID",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiProductStagingRulesCount",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiVirtualModelRulesCount",
  "storageKey": null
},
v45 = [
  (v24/*:: as any*/),
  (v21/*:: as any*/)
],
v46 = {
  "condition": "skipCollage",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*:: as any*/),
      "concreteType": "GridRule",
      "kind": "LinkedField",
      "name": "gridRulesByProduct",
      "plural": true,
      "selections": (v45/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gridRulesCount",
      "storageKey": null
    }
  ]
},
v47 = {
  "alias": null,
  "args": (v27/*:: as any*/),
  "concreteType": "AreaBackgroundRuleTool",
  "kind": "LinkedField",
  "name": "areaBackgroundRulesByProduct",
  "plural": true,
  "selections": (v45/*:: as any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaBackgroundRulesCount",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areaBackgroundRuleID",
  "storageKey": null
},
v50 = {
  "condition": "skipExtraOptions",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v23/*:: as any*/),
      "concreteType": "AdditionalAttribute",
      "kind": "LinkedField",
      "name": "additionalAttributesByProduct",
      "plural": false,
      "selections": [
        (v24/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalAttributeID",
          "storageKey": null
        },
        (v21/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": 0
        }
      ],
      "concreteType": "AdditionalAttribute",
      "kind": "LinkedField",
      "name": "myAdditionalAttributes",
      "plural": true,
      "selections": (v40/*:: as any*/),
      "storageKey": "myAdditionalAttributes(status:0)"
    }
  ]
},
v51 = {
  "condition": "skipPrintingMethods",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v32/*:: as any*/),
      "concreteType": "PrintTypesConnection",
      "kind": "LinkedField",
      "name": "printTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PrintTypesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PrintType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v24/*:: as any*/),
                (v33/*:: as any*/),
                (v21/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "printTypes(first:200)"
    }
  ]
},
v52 = {
  "condition": "skipPlacement",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "modelId"
        }
      ],
      "concreteType": "PlacementOutput",
      "kind": "LinkedField",
      "name": "placementsOutput",
      "plural": true,
      "selections": [
        (v24/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "placementOutputID",
          "storageKey": null
        },
        (v21/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v53 = {
  "condition": "skipBulkVariations",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "productId",
          "variableName": "modelId"
        }
      ],
      "concreteType": "ProductMultipleVariantsRule",
      "kind": "LinkedField",
      "name": "productMultipleVariantsRule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attributeCodes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameAndNumberEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skipOptionForNameAndNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bulkAsNameAndNumberEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableImportCSV",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "options",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v54 = {
  "condition": "skipMoq",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moqRulesCount",
      "storageKey": null
    }
  ]
},
v55 = {
  "condition": "skipQuote",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quoteRulesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuoteRule",
      "kind": "LinkedField",
      "name": "quoteRulesList",
      "plural": true,
      "selections": [
        (v24/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteRuleID",
          "storageKey": null
        },
        (v21/*:: as any*/)
      ],
      "storageKey": null
    }
  ]
},
v56 = [
  {
    "kind": "Literal",
    "name": "onlybackground",
    "value": false
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v58 = {
  "condition": "skipExtensionFields",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExtensionField",
      "kind": "LinkedField",
      "name": "extensionFields",
      "plural": true,
      "selections": (v45/*:: as any*/),
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "condition": "skipTemplates",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v19/*:: as any*/),
            "concreteType": "DesignTemplate",
            "kind": "LinkedField",
            "name": "designTemplates",
            "plural": true,
            "selections": [
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v25/*:: as any*/),
      (v29/*:: as any*/),
      (v34/*:: as any*/),
      (v36/*:: as any*/),
      {
        "condition": "skipAI",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v38/*:: as any*/),
          (v39/*:: as any*/),
          (v41/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithAISettingDTO",
            "kind": "LinkedField",
            "name": "designWithAISetting",
            "plural": false,
            "selections": [
              (v42/*:: as any*/)
            ],
            "storageKey": null
          },
          (v43/*:: as any*/),
          (v44/*:: as any*/)
        ]
      },
      (v46/*:: as any*/),
      {
        "condition": "skipAreaBackground",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v47/*:: as any*/),
          (v48/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AreaBackgroundRuleTool",
            "kind": "LinkedField",
            "name": "areaBackgroundRules",
            "plural": true,
            "selections": [
              (v49/*:: as any*/),
              (v21/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v50/*:: as any*/),
      (v51/*:: as any*/),
      (v52/*:: as any*/),
      (v53/*:: as any*/),
      (v54/*:: as any*/),
      (v55/*:: as any*/),
      {
        "condition": "skipImages",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v56/*:: as any*/),
            "concreteType": "ImageMacroCategory",
            "kind": "LinkedField",
            "name": "imageMacroCategories",
            "plural": true,
            "selections": [
              (v57/*:: as any*/)
            ],
            "storageKey": "imageMacroCategories(onlybackground:false)"
          }
        ]
      },
      (v58/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v18/*:: as any*/),
      (v12/*:: as any*/),
      (v17/*:: as any*/),
      (v13/*:: as any*/),
      (v15/*:: as any*/),
      (v3/*:: as any*/),
      (v6/*:: as any*/),
      (v4/*:: as any*/),
      (v8/*:: as any*/),
      (v14/*:: as any*/),
      (v11/*:: as any*/),
      (v5/*:: as any*/),
      (v10/*:: as any*/),
      (v16/*:: as any*/),
      (v9/*:: as any*/),
      (v7/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "condition": "skipTemplates",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v19/*:: as any*/),
            "concreteType": "DesignTemplate",
            "kind": "LinkedField",
            "name": "designTemplates",
            "plural": true,
            "selections": [
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v24/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v25/*:: as any*/),
      (v29/*:: as any*/),
      (v34/*:: as any*/),
      (v36/*:: as any*/),
      {
        "condition": "skipAI",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v38/*:: as any*/),
          (v39/*:: as any*/),
          (v41/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithAISettingDTO",
            "kind": "LinkedField",
            "name": "designWithAISetting",
            "plural": false,
            "selections": [
              (v42/*:: as any*/),
              (v24/*:: as any*/)
            ],
            "storageKey": null
          },
          (v43/*:: as any*/),
          (v44/*:: as any*/)
        ]
      },
      (v46/*:: as any*/),
      {
        "condition": "skipAreaBackground",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v47/*:: as any*/),
          (v48/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AreaBackgroundRuleTool",
            "kind": "LinkedField",
            "name": "areaBackgroundRules",
            "plural": true,
            "selections": [
              (v49/*:: as any*/),
              (v21/*:: as any*/),
              (v24/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v50/*:: as any*/),
      (v51/*:: as any*/),
      (v52/*:: as any*/),
      (v53/*:: as any*/),
      (v54/*:: as any*/),
      (v55/*:: as any*/),
      {
        "condition": "skipImages",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v56/*:: as any*/),
            "concreteType": "ImageMacroCategory",
            "kind": "LinkedField",
            "name": "imageMacroCategories",
            "plural": true,
            "selections": [
              (v57/*:: as any*/),
              (v24/*:: as any*/)
            ],
            "storageKey": "imageMacroCategories(onlybackground:false)"
          }
        ]
      },
      (v58/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "966937b5db6101aae5868d12de1820f6",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ToolDataQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ToolDataQuery(\n  $productId: Long!\n  $modelId: ID!\n  $pricingFirst: Int!\n  $skipTemplates: Boolean!\n  $skipPresetConfigurations: Boolean!\n  $skipShapes: Boolean!\n  $skipPricing: Boolean!\n  $skipProfanity: Boolean!\n  $skipAI: Boolean!\n  $skipCollage: Boolean!\n  $skipAreaBackground: Boolean!\n  $skipExtraOptions: Boolean!\n  $skipPrintingMethods: Boolean!\n  $skipPlacement: Boolean!\n  $skipBulkVariations: Boolean!\n  $skipMoq: Boolean!\n  $skipQuote: Boolean!\n  $skipImages: Boolean!\n  $skipExtensionFields: Boolean!\n) {\n  designTemplates(productId: $productId) @skip(if: $skipTemplates) {\n    designTemplateId\n    name\n    previewUrl\n    id\n  }\n  presetConfigurationsByProduct(productID: $modelId) @skip(if: $skipPresetConfigurations) {\n    id\n    compositionID\n    name\n    previewImageUrl\n  }\n  shapesAssignmentsForProduct(productID: $productId) @skip(if: $skipShapes) {\n    forProduct\n    printTypesIDs\n  }\n  shapesAssignments @skip(if: $skipShapes) {\n    productsIDs\n    printTypesIDs\n  }\n  hasShapes @skip(if: $skipShapes)\n  shapesCount @skip(if: $skipShapes)\n  pricingsDetailed(productID: $productId, first: $pricingFirst) @skip(if: $skipPricing) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  pricings(first: 200) @skip(if: $skipPricing) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n        printTypes {\n          printTypeID\n          printTypeName\n        }\n        products {\n          productID\n        }\n      }\n    }\n  }\n  profanityFilterRulesForProduct(productID: $productId) @skip(if: $skipProfanity) {\n    productRule {\n      ruleID\n      ruleName\n    }\n    printTypeRules {\n      key\n      value {\n        ruleID\n        ruleName\n      }\n    }\n  }\n  profanityFilterRulesCount @skip(if: $skipProfanity)\n  aiProductStagingRulesByProduct(productID: $productId) @skip(if: $skipAI) {\n    id\n    name\n    productIDs\n    printTypeIDs\n  }\n  aiVirtualModelRulesByProduct(productID: $productId) @skip(if: $skipAI) {\n    id\n    name\n    productIDs\n    printTypeIDs\n  }\n  imageGeneration @skip(if: $skipAI) {\n    id\n  }\n  designWithAISetting @skip(if: $skipAI) {\n    settingsID\n    id\n  }\n  aiProductStagingRulesCount @skip(if: $skipAI)\n  aiVirtualModelRulesCount @skip(if: $skipAI)\n  gridRulesByProduct(productID: $productId) @skip(if: $skipCollage) {\n    id\n    name\n  }\n  gridRulesCount @skip(if: $skipCollage)\n  areaBackgroundRulesByProduct(productID: $productId) @skip(if: $skipAreaBackground) {\n    id\n    name\n  }\n  areaBackgroundRulesCount @skip(if: $skipAreaBackground)\n  areaBackgroundRules @skip(if: $skipAreaBackground) {\n    areaBackgroundRuleID\n    name\n    id\n  }\n  additionalAttributesByProduct(productID: $modelId) @skip(if: $skipExtraOptions) {\n    id\n    additionalAttributeID\n    name\n  }\n  myAdditionalAttributes(status: 0) @skip(if: $skipExtraOptions) {\n    id\n  }\n  printTypes(first: 200) @skip(if: $skipPrintingMethods) {\n    edges {\n      node {\n        id\n        printTypeID\n        name\n      }\n    }\n  }\n  placementsOutput(id: $modelId) @skip(if: $skipPlacement) {\n    id\n    placementOutputID\n    name\n    isEnabled\n  }\n  productMultipleVariantsRule(productId: $modelId) @skip(if: $skipBulkVariations) {\n    attributeCodes\n    nameAndNumberEnabled\n    skipOptionForNameAndNumber\n    bulkAsNameAndNumberEnabled\n    enableImportCSV\n    options\n  }\n  moqRulesCount @skip(if: $skipMoq)\n  quoteRulesCount @skip(if: $skipQuote)\n  quoteRulesList @skip(if: $skipQuote) {\n    id\n    quoteRuleID\n    name\n  }\n  imageMacroCategories(onlybackground: false) @skip(if: $skipImages) {\n    hasImages\n    id\n  }\n  extensionFields @skip(if: $skipExtensionFields) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "60eb251c5c78e535bc9b9c5934e2d7ec";

export default node;
